/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lucky_Keen_Sheep_EvokeInputs */

const fr_lucky_keen_sheep_evoke = /** @type {(inputs: Lucky_Keen_Sheep_EvokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilise l'application pour savoir les poids que tu dois charger en fonction de la charge global`)
};

/**

* @param {Lucky_Keen_Sheep_EvokeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const lucky_keen_sheep_evoke = /** @type {((inputs?: Lucky_Keen_Sheep_EvokeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lucky_Keen_Sheep_EvokeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_lucky_keen_sheep_evoke(inputs)
});